import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Grid,
  Avatar,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Divider,
  Autocomplete,
  TextField,
  IconButton,
  ClickAwayListener,
} from '@mui/material';
import {
  Email,
  Work,
  CalendarToday,
  Search as SearchIcon,
  Close,
  KeyboardArrowDown,
} from '@mui/icons-material';

export const GestionFinanciera = () => {
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [open, setOpen] = useState(false);
  const [menuPosition, setMenuPosition] = useState({ top: 0, left: 0 });

  const handleToggle = (event: any) => {
    const rect = event.currentTarget.getBoundingClientRect();
    setMenuPosition({ top: rect.bottom + window.scrollY, left: rect.left });
    setOpen(!open);
  };

  const handleClose = () => setOpen(false);

  const izquierda = [
    'Novedades',
    'Anticipos',
    'Incapacidades',
    'Ausencias no remuneradas',
    'Ausencias remuneradas',
    'Vacaciones',
    'Primas',
    'Cesantías',
    'Retiros',
    'Certificado de ingresos',
    'Nómina electrónica',
    'PILA',
  ];

  const derecha = [
    'Modificación de salario',
    'Conceptos fijos',
    'Administradoras de fondos',
    'Préstamos',
    'Documentos',
    'Retención en la fuente',
    'Contabilidad',
    'Provisiones extralegales',
    'Distribución contable',
    'Auditoría',
  ];

  const empleado = {
    nombre: 'Jorge Andres Hol Ruiz',
    cargo: 'Líder de Recepción',
    area: 'Recepción',
    identificacion: 'CC 1143960429',
    ingreso: '04/05/2022',
    correo: 'andresholr@hotmail.com',
    salario: 1500000,
    valorHora: 6818.18,
    jornada: 'Lunes a sábado 360 días',
    ultimaLiquidacion: 790000,
  };

  const liquidacion = [
    { item: 'Salario Básico', cantidad: '15 Días', valor: 750000 },
    { item: 'Subsidio de Transporte', cantidad: '15 Días', valor: 100000 },
  ];

  return (
    <Box sx={{ p: 4, backgroundColor: '#f5f7fa', minHeight: '100vh' }}>
      {/* === BUSCADOR DE EMPLEADOS === */}
      <Paper elevation={3} sx={{ padding: 3, borderRadius: '16px', mb: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
          <SearchIcon color="action" sx={{ mr: 1 }} />
          <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
            Buscar Empleado
          </Typography>
        </Box>
        <Autocomplete
          fullWidth
          options={[
            { label: 'Juan Pérez', id: 1, avatar: 'JP' },
            { label: 'Ana García', id: 2, avatar: 'AG' },
            { label: 'Carlos Rodríguez', id: 3, avatar: 'CR' },
          ]}
          getOptionLabel={(option) => option.label}
          value={selectedEmployee}
          onChange={(event, newValue: any) => setSelectedEmployee(newValue)}
          renderInput={(params) => (
            <TextField {...params} label="Escribe el nombre del empleado..." />
          )}
          renderOption={(props, option) => (
            <Box component="li" {...props}>
              <Avatar sx={{ mr: 2, width: 32, height: 32, bgcolor: 'primary.light' }}>
                {option.avatar}
              </Avatar>
              {option.label}
            </Box>
          )}
        />
      </Paper>

      {/* === PERFIL DEL EMPLEADO === */}
      <Card sx={{ p: 3, mb: 3, borderRadius: 3, boxShadow: 3, overflow: 'visible' }}>
        <Grid container spacing={3}>
          <Grid size={{ xs: 12, md: 8 }} display="flex" alignItems="center">
            <Avatar sx={{ width: 80, height: 80, mr: 2, bgcolor: '#1976d2', fontSize: 32 }}>
              {empleado.nombre.charAt(0)}
            </Avatar>
            <Box>
              <Typography variant="h6" fontWeight={600}>
                {empleado.nombre}
              </Typography>
              <Typography color="text.secondary">{empleado.cargo}</Typography>
              <Typography variant="body2" mt={1}>
                <strong>Área:</strong> {empleado.area}
              </Typography>
              <Typography variant="body2">
                <strong>Identificación:</strong> {empleado.identificacion}
              </Typography>
              <Typography variant="body2">
                <CalendarToday fontSize="small" sx={{ mr: 1 }} />
                Fecha ingreso: {empleado.ingreso}
              </Typography>
              <Typography variant="body2">
                <Email fontSize="small" sx={{ mr: 1 }} />
                {empleado.correo}
              </Typography>

              {/* === MENÚ GESTIONAR === */}
              <Box sx={{ position: 'relative', display: 'inline-block', pt: 2 }}>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    backgroundColor: '#f7f9fc',
                    borderRadius: 1,
                    p: 0.5,
                    border: '1px solid #d1d5db',
                  }}
                >
                  <Button
                    variant="text"
                    color="primary"
                    endIcon={<KeyboardArrowDown />}
                    onClick={handleToggle}
                    sx={{
                      textTransform: 'none',
                      fontWeight: 600,
                      color: '#1976d2',
                    }}
                  >
                    Gestionar
                  </Button>

                  <TextField
                    size="small"
                    placeholder="Incapacidades, prima, modificación salario, etc."
                    variant="standard"
                    sx={{
                      ml: 2,
                      width: 350,
                      '& input': { fontSize: 14 },
                    }}
                  />
                </Box>
              </Box>
            </Box>
          </Grid>

          <Grid size={{ xs: 12, md: 4 }}>
            <Box textAlign="right">
              <Typography variant="subtitle2" color="text.secondary">
                Salario
              </Typography>
              <Typography variant="h6" fontWeight={700}>
                COP {empleado.salario.toLocaleString()}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Valor Hora: COP {empleado.valorHora.toLocaleString()}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Jornada: {empleado.jornada}
              </Typography>
              <Divider sx={{ my: 1 }} />
              <Typography variant="subtitle2" color="text.secondary">
                Última Liquidación
              </Typography>
              <Typography variant="h6" fontWeight={700} color="success.main">
                COP {empleado.ultimaLiquidacion.toLocaleString()}
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Card>

      {/* === MENÚ DESPLEGABLE GLOBAL === */}
      {open &&
        ReactDOM.createPortal(
          <ClickAwayListener onClickAway={handleClose}>
            <Paper
              elevation={5}
              sx={{
                position: 'absolute',
                top: menuPosition.top,
                left: menuPosition.left,
                zIndex: 2000,
                p: 2,
                borderRadius: 2,
                width: 600,
              }}
            >
              <Box display="flex" justifyContent="space-between" mb={1}>
                <Typography variant="subtitle1" fontWeight={600}>
                  Opciones de Gestión
                </Typography>
                <IconButton size="small" onClick={handleClose}>
                  <Close fontSize="small" />
                </IconButton>
              </Box>
              <Divider sx={{ mb: 2 }} />

              <Grid container spacing={2}>
                <Grid size={{ xs: 6 }}>
                  {izquierda.map((item) => (
                    <Typography
                      key={item}
                      sx={{
                        py: 0.5,
                        px: 1,
                        borderRadius: 1,
                        cursor: 'pointer',
                        '&:hover': { backgroundColor: '#f0f4ff' },
                        fontSize: 14,
                      }}
                    >
                      {item}
                    </Typography>
                  ))}
                </Grid>

                <Grid size={{ xs: 6 }}>
                  {derecha.map((item) => (
                    <Typography
                      key={item}
                      sx={{
                        py: 0.5,
                        px: 1,
                        borderRadius: 1,
                        cursor: 'pointer',
                        '&:hover': { backgroundColor: '#f0f4ff' },
                        fontSize: 14,
                      }}
                    >
                      {item}
                    </Typography>
                  ))}
                </Grid>
              </Grid>
            </Paper>
          </ClickAwayListener>,
          document.body
        )}

      {/* Detalle de liquidación */}
      <Card sx={{ p: 3, borderRadius: 3, boxShadow: 2 }}>
        <Typography variant="h6" mb={2}>
          Detalle de Liquidación
        </Typography>
        <Typography variant="subtitle1" fontWeight={600} mb={2}>
          Total a pagar:{' '}
          <Typography component="span" color="primary" fontWeight={700} fontSize="1.1rem">
            COP {empleado.ultimaLiquidacion.toLocaleString()}
          </Typography>
        </Typography>

        <TableContainer component={Paper} variant="outlined">
          <Table>
            <TableHead>
              <TableRow sx={{ backgroundColor: '#f0f4f8' }}>
                <TableCell sx={{ fontWeight: 'bold' }}>ITEM</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>CANTIDAD</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>VALOR</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {liquidacion.map((row, i) => (
                <TableRow key={i}>
                  <TableCell>{row.item}</TableCell>
                  <TableCell>{row.cantidad}</TableCell>
                  <TableCell>COP {row.valor.toLocaleString('es-CO')}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        <Box display="flex" justifyContent="flex-end" mt={3} gap={2}>
          <Button variant="outlined" color="primary">
            Descargar volante
          </Button>
          <Button variant="contained" color="success">
            Enviar volante
          </Button>
        </Box>
      </Card>
    </Box>
  );
};

// import React, { useState } from 'react'
// import { BreadCrumbsAndTitle } from '../../components/generics/BreadCrumbsAndTitle'
// import { AlertsInformativos } from '../../components/generics/AlertsInformativos'
// import { Divider, Grid, Paper, Typography, Chip, Autocomplete, TextField, Avatar, Box } from '@mui/material'
// import { mtDividerUpTable, paddingCardsTables } from '../../commons'
// import { alertInformativo } from '../../commons/texts'
// import BusinessIcon from '@mui/icons-material/Business';
// import SearchIcon from '@mui/icons-material/Search';

// export const GestionFinanciera = () => {

//   const [selectedEmployee, setSelectedEmployee] = useState(null);

//   const currentDate = new Date().toLocaleDateString('es-ES', {
//     year: 'numeric',
//     month: 'long',
//     day: 'numeric'
//   });

//   // Datos de ejemplo para los empleados
//   const employees = [
//     { label: 'Juan Pérez', id: 1 },
//     { label: 'Ana García', id: 2 },
//     { label: 'Carlos Rodríguez', id: 3 },
//     { label: 'Laura Martínez', id: 4 },
//     { label: 'Miguel Sánchez', id: 5 },
//   ];

//   return (
//     <div>

//         <BreadCrumbsAndTitle
//             title="Gestion Financiera"
//             mainModule="Talento Humano"
//             parent="Gestion Financiera"
//             action="" />

//         <AlertsInformativos type={'info'} title={'info'} content={alertInformativo.gestionFinanciera} />

//         <Divider sx={{ marginBottom: mtDividerUpTable }}/>

//         <Grid container spacing={4} sx={{  marginTop: paddingCardsTables }}>
//             {/* Columna Izquierda: Información de la Empresa */}
//             <Grid  size={{ xs: 12, md: 5}} >
//                 <Paper elevation={3} sx={{ padding: 3, borderRadius: '16px', display: 'flex', flexDirection: 'column', alignItems: 'center', height: '100%', textAlign: 'center' }}>
//                     <Avatar sx={{ width: 80, height: 80, bgcolor: 'primary.main', marginBottom: 2 }}>
//                         <BusinessIcon sx={{ fontSize: 50 }} />
//                     </Avatar>
//                     <Typography variant="h5" component="div" gutterBottom sx={{ fontWeight: 'bold' }}>
//                         Qi Hotels
//                     </Typography>
//                     <Typography variant="body1" color="text.secondary" gutterBottom>
//                         {currentDate}
//                     </Typography>
//                     <Chip label="Activo" color="success" sx={{ marginTop: 1, fontWeight: 'bold' }} />
//                 </Paper>
//             </Grid>

//             {/* Columna Derecha: Buscador de Empleados */}
//             <Grid size={{ xs: 12, md: 7 }}>
//                 <Paper elevation={3} sx={{ padding: 3, borderRadius: '16px', height: '100%' }}>
//                     <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
//                         <SearchIcon color="action" sx={{ mr: 1 }} />
//                         <Typography variant="h6" component="div" sx={{ fontWeight: 'bold' }}>
//                             Buscar Empleado
//                         </Typography>
//                     </Box>
//                     <Autocomplete
//                         fullWidth
//                         options={employees}
//                         getOptionLabel={(option) => option.label}
//                         value={selectedEmployee}
//                         onChange={(event, newValue:any) => {
//                           setSelectedEmployee(newValue);
//                         }}
//                         renderInput={(params) => <TextField {...params} label="Nombre del empleado" variant="outlined" />}
//                     />
//                 </Paper>
//             </Grid>
//         </Grid>

//     </div>
//   )
// }
